// extracted by mini-css-extract-plugin
module.exports = {"login":"MigrateStaffAccountForm_login__Mx1j8","cta":"MigrateStaffAccountForm_cta__1M4Dh"};